enum ErrorMessages {
  // Fetch Errors
  FetchOffersError = 'Offers Fetch Error',
  FetchDealersError = 'Dealers Fetch Error',
  FetchServiceOffersError = 'Service Offers Fetch Error',
  FetchLocationError = 'Location Fetch Error'
}

export default ErrorMessages;
